import { type DataDisplayType } from '../dataDisplayType'

import { forCount } from './forCount'
import { addPtsUnit } from './internal/addPtsUnit'
import { ratioToPts } from './ratioToPts'

/**
 * 集計数を"pts"単位付き文字列と単位なし文字列にフォーマットします。
 *
 * @param count - 集計数。
 * @param ratio - 総数に対する集計数の比率。
 * @param tamRatio - 集計数と推定人口の比率。
 * @param dataDisplayType - データ表示タイプ。
 * @returns "pts"単位付き文字列と単位なし文字列。
 */
export function countToPts(
  count: number,
  ratio: number,
  tamRatio: number,
  dataDisplayType: DataDisplayType,
): [ptsText: string, nonUnitText: string] {
  if (dataDisplayType === 'percentage') {
    return ratioToPts(ratio)
  }

  const nonUnitText = forCount(count, ratio, tamRatio, dataDisplayType)
  const ptsText = addPtsUnit(nonUnitText)

  return [ptsText, nonUnitText]
}
